import React from "react";
import { Box } from "@mui/material";
import { DOTTED_LINE } from "my-tax/constants";

interface MyTaxFourChildrenDependentsInfoTableRowProps {
  name: string;
  taxNumber?: string;
  birthPlace: string;
  birthDate: string;
  mothersName: string;
}

export const MyTaxFourChildrenDependentsInfoTableRow: React.FC<MyTaxFourChildrenDependentsInfoTableRowProps> = ({
  name,
  taxNumber,
  birthPlace,
  birthDate,
  mothersName,
}) => {
  return (
    <Box
      display="flex"
      alignItems="center"
      style={{
        marginBottom: "8px",
        marginTop: "8px",
        fontSize: "15px",
        fontFamily: "EB Garamond",
      }}
    >
      <style type="text/css" media="print">
        {
          "\
            @page { size: landscape; }\
        "
        }
      </style>

      <Box width="200px" textAlign="center" marginLeft="22px">
        {name}
      </Box>
      <Box width="140px" textAlign="center" marginLeft="80px">
        {taxNumber ? taxNumber : DOTTED_LINE}
      </Box>
      <Box width="274px" textAlign="center" marginLeft="73px">
        {birthPlace}, {birthDate}
      </Box>
      <Box width="200px" textAlign="center">
        {mothersName}
      </Box>
    </Box>
  );
};

export default MyTaxFourChildrenDependentsInfoTableRow;
